export function isEventFromTerminal(event: KeyboardEvent): boolean {
    const target = event.target
    return target instanceof HTMLElement && !!target.closest(".xterm")
}
